"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Range_1 = __importDefault(require("../../../Util/Range"));
const State_1 = require("../types/State");
const byDateSort_1 = __importDefault(require("../../../BusinessLogicLayer/byDateSort"));
const getRecoveryRange_1 = require("./graphql/getRecoveryRange");
const getChecklistSettings_1 = require("./graphql/getChecklistSettings");
class Recovery {
    constructor(client, dateTimeProvider) {
        this.getDateRange = async (customerId, dateRange) => {
            const res = await this.client.fetch("getRecoveryInRange", (0, getRecoveryRange_1.prepareQueryGetRecoveryInRange)({
                userId: parseInt(customerId),
                ...dateRange,
            }), null);
            const { currentSettings, } = await this.client.fetch("getChecklistSettings", (0, getChecklistSettings_1.prepareQueryGetChecklistSettings)({ memberId: parseInt(customerId) }), null);
            const disabledChecklistItems = currentSettings
                .filter(this.filterDisabledChecklistSettings)
                .map(this.mapDisabledChecklistSettings);
            const days = res.progressCollection.map(this.mapWeek).sort(byDateSort_1.default);
            return {
                days,
                disabledChecklistItems,
            };
        };
        this.mapWeek = (progressItem) => {
            return {
                date: this.dateTimeProvider.fromDateTimeToDate(progressItem.date),
                dayType: progressItem.dayType,
                recovery: {
                    sleepHours: progressItem.sleepHours,
                    sleepHoursRange: progressItem.sleepStart && progressItem.sleepEnd
                        ? new Range_1.default(progressItem.sleepStart, progressItem.sleepEnd)
                        : null,
                    sleepQuality: progressItem.sleepQuality,
                    heartBeat: progressItem.heartRate,
                    muscleStrain: progressItem.muscleStrain,
                    stressLevel: progressItem.stressLevel,
                },
                progress: {
                    motivation: {
                        value: progressItem.motivation,
                        reason: progressItem.motivationReason,
                    },
                    training: this.progressStatus(progressItem.trained, progressItem.missedTrainingReason),
                    lesson: this.progressStatus(progressItem.didLesson, progressItem.missedLessonReason),
                    water: this.progressStatus(progressItem.drankWater),
                    supplements: this.progressStatus(progressItem.supplemented),
                    nutrition: this.progressStatusNutrition(progressItem.ateAsRecommended, progressItem.ateAsRecommendedPercentage),
                },
            };
        };
        this.filterDisabledChecklistSettings = ({ id, value, }) => {
            return id.startsWith("checklist.checkin") && value === "off";
        };
        this.mapDisabledChecklistSettings = ({ id }) => {
            return id.split("checklist.checkin.")[1];
        };
        this.progressStatus = (state, reason = null) => {
            return {
                status: (0, State_1.asBool)(state),
                reason,
            };
        };
        this.progressStatusNutrition = (state, percent, reason = null) => {
            if (percent >= 80) {
                return {
                    status: percent,
                    reason,
                };
            }
            return this.progressStatus(state, reason);
        };
        this.client = client;
        this.dateTimeProvider = dateTimeProvider;
    }
}
exports.default = Recovery;
//# sourceMappingURL=Recovery.js.map